import React from 'react';

import TableContainer from './TableContainer';
import useTableConfigInit from './useTableConfigInit';
import { registerGetCellRenderValue } from '../bridge/tableSearchRuntime';
import { getCellRenderValue } from './utils/dataUtils/cell/tableCellRenderValueUtils';

import 'handsontable/styles/handsontable.min.css';
import 'handsontable/styles/ht-theme-main.min.css';

// Register the cell renderer for table search functionality.
registerGetCellRenderValue(getCellRenderValue);

export type TableProps = React.ComponentProps<typeof TableContainer>;

/**
 * Initialises table runtime configuration once the lazy editor has mounted.
 * Can be consolidated into TableContainer once it is converted to TS/FC.
 */
const TableEditor: React.FC<TableProps> = (props) => {
    useTableConfigInit();

    return <TableContainer {...props} />;
};

export default TableEditor;
